import { useEffect, useState } from "react";
import { ParametrosAPI } from "../http-requests";
import { matchPath } from "react-router";

function getCatalogPathData(pathname) {
    const normalizedPath = (pathname || "").replace(/^\/+|\/+$/g, "");
    const pathParts = normalizedPath.split("/");
    const catalogIndex = pathParts.indexOf("catalogos");

    if (catalogIndex === -1) {
        return { isKids: false, codBiblioteca: 0 };
    }

    const catalogSlug = (pathParts[catalogIndex + 1] || "").toLowerCase();
    const rawCodBiblioteca = pathParts[catalogIndex + 2];
    const parsedCodBiblioteca = Number.parseInt(rawCodBiblioteca, 10);

    return {
        isKids: catalogSlug === "kids",
        codBiblioteca: Number.isNaN(parsedCodBiblioteca) ? 0 : parsedCodBiblioteca,
    };
}

export function useServiceData(lang) {
    const [serviceData, setServiceData] = useState(null);

    const { isKids, codBiblioteca } = getCatalogPathData(window.location.pathname);

    useEffect(() => {
        let cancelled = false;

        const storageKey = `serviceData_${isKids ? 'K' : 'C'}_${codBiblioteca}_${lang}`;
        const serviceStorage = sessionStorage.getItem(storageKey);

        if (serviceStorage) {
            setServiceData(JSON.parse(serviceStorage));
            return;
        }

        ParametrosAPI.buscaDadosSecao2(isKids ? 'K' : 'C', codBiblioteca)
            .then(resp => {
                if (!cancelled && resp.data) {
                    // resp.data agora tem:
                    // { siglaInstituicao, dados }
                    setServiceData(resp.data);
                    sessionStorage.setItem(storageKey, JSON.stringify(resp.data));
                }
            })
            .catch(error => {
                console.error("Erro ao buscar serviceData:", error);
            });

        return () => {
            cancelled = true;
        };

    }, [lang, isKids, codBiblioteca]);

    return serviceData;
}

export function useFaqsData(lang) {
    const [faqsData, setFaqsData] = useState(null);
    const isKids = matchPath({ path: "/catalogos/kids/*", end: false }, window.location.pathname);

    useEffect(() => {
        let cancelled = false;
        const faqsStorage = sessionStorage.getItem(`faqsData_${isKids ? 'K' : 'C'}_${lang}`);
        if (faqsStorage) {
            const parsed = JSON.parse(faqsStorage);
            setFaqsData(parsed);
            return;
        }
        ParametrosAPI.buscaFAQ(isKids ? 'K' : 'C')
            .then(resp => {
                if (!cancelled) {
                    setFaqsData(resp.data);
                    sessionStorage.setItem(`faqsData_${isKids ? 'K' : 'C'}_${lang}`, JSON.stringify(resp.data));
                }
            });
        return () => { cancelled = true; }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [lang]);
    return faqsData;
}

export function usePrefiltersData(lang) {
    const [prefiltersData, setPrefiltersData] = useState(null);

    useEffect(() => {
        let cancelled = false;
        ParametrosAPI.buscaDadosPrefiltros()
            .then(resp => {
                if (!cancelled) setPrefiltersData(resp.data);
            });
        return () => { cancelled = true; }
    }, [lang]);

    return prefiltersData;
}